module.exports = __webpack_public_path__ + "img/branding-logo-huisstijl-ivoor-brillenmerk-verpakking-2.4fe8da67.jpg";